import { Button } from '@mui/material';
import * as React from 'react';
import API from '../../api/axiosConfig';
import { useUser } from '../../context/UserContext';

export default function InsuranceDigestButton(){

    const { userEmail } = useUser();
    

    const handleClick = async () => {
        // TODO: Build post request for backend to send email summary of all open enrollment database entries.
        try {

            // Fetch email
            await API.post('/api/users/openenrollment/summary');

            // See if the operation was successful
            alert("Open enrollment summary sent.");

        } catch (err) {

        }
    };

    if (userEmail === "gary@s3k.io" || userEmail === "cj.polesovsky@s3k.io") {
        return (
            <Button variant="outlined" onClick={handleClick}>
                Get Open Enrollment Summary
            </Button>
        );
    }

    // Return the rendered button if Gary or CJ is the user signed into the system. Otherwise, return nothing.
    return null;
}